import { render, staticRenderFns } from "./AICopilot.vue?vue&type=template&id=4b7be8d0&scoped=true"
import script from "./AICopilot.vue?vue&type=script&lang=js"
export * from "./AICopilot.vue?vue&type=script&lang=js"
import style0 from "./AICopilot.vue?vue&type=style&index=0&id=4b7be8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7be8d0",
  null
  
)

export default component.exports